import CreativeCardContainer from "../../components/bonusUi/creativeCard";

const CreativeCard = () => {
  return <CreativeCardContainer />;
};

export default CreativeCard;
